import { render, staticRenderFns } from "./BtnInvalid.vue?vue&type=template&id=451c7b22&"
import script from "./BtnInvalid.vue?vue&type=script&lang=js&"
export * from "./BtnInvalid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports